<form [formGroup]="customerForm">
    <div class="row">
        <mat-form-field class="col" appearance="fill">
            <mat-label>Email*</mat-label>
            <mat-placeholder>Email</mat-placeholder>
            <input class="form-control" type="email" matInput formControlName="email" (blur)="findUser()" />
            <mat-error>Invalid Email Address</mat-error>
        </mat-form-field>

        <mat-form-field class="col" appearance="fill">
            <mat-label>Mobile Phone*</mat-label>
            <input
                class="form-control"
                type="text"
                matInput
                appPhoneMask
                formControlName="phone"
                id="phone-number"
                placeholder="(XXX) XXX-XXXX"
                maxlength="14"
            />
            <mat-error>Invalid Phone Number</mat-error>
        </mat-form-field>
    </div>
    <div class="row">
        <mat-form-field class="col" appearance="fill">
            <mat-label>First Name*</mat-label>
            <mat-placeholder>First Name</mat-placeholder>
            <input class="form-control" type="text" matInput formControlName="firstName" />
            <mat-error>Invalid First Name</mat-error>
        </mat-form-field>

        <mat-form-field class="col" appearance="fill">
            <mat-label>Last Name*</mat-label>
            <mat-placeholder>Last Name</mat-placeholder>
            <input class="form-control" type="text" matInput formControlName="lastName" />
            <mat-error>Invalid Last Name</mat-error>
        </mat-form-field>
    </div>
</form>
